"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _Answer = _interopRequireDefault(require("@insided/shared/icons/Answer"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var _Label = _interopRequireDefault(require("@insided/shared/uikit/Label"));

var _DateTimeWithTooltip = _interopRequireDefault(require("./shared/TopicHeader/DateTimeWithTooltip"));

var BestAnswer = function BestAnswer(_ref) {
  var publicReplyId = _ref.publicReplyId,
      content = _ref.content,
      username = _ref.username,
      authorId = _ref.authorId,
      authorAvatar = _ref.authorAvatar,
      authorUrl = _ref.authorUrl,
      authorRank = _ref.authorRank,
      authorTitle = _ref.authorTitle,
      authorSignature = _ref.authorSignature,
      repliedAt = _ref.repliedAt;
  var postUrl = typeof window !== 'undefined' ? "".concat(window.location.pathname, "/?postid=").concat(publicReplyId, "#post").concat(publicReplyId) : null; // Rich display when authorAvatar is provided (feature flag enabled)

  var isRichDisplay = !!authorAvatar;

  if (isRichDisplay) {
    var _ref2;

    var user = {
      id: authorId,
      name: username,
      avatar: authorAvatar,
      url: authorUrl !== null && authorUrl !== void 0 ? authorUrl : '',
      rank: authorRank ? {
        name: authorRank
      } : null,
      userTitle: authorTitle !== null && authorTitle !== void 0 ? authorTitle : ''
    };
    var replyTime = repliedAt ? new Date(repliedAt).getTime() : null;
    var userRankTitle = (_ref2 = authorTitle !== null && authorTitle !== void 0 ? authorTitle : authorRank) !== null && _ref2 !== void 0 ? _ref2 : '';
    return (0, _preact.h)("div", {
      className: "threaded-reply-item-wrapper"
    }, (0, _preact.h)("div", {
      className: "threaded-reply-item qa-answer-field",
      role: "article",
      "aria-label": "Best answer by ".concat(username)
    }, (0, _preact.h)("div", {
      className: "topic-header"
    }, (0, _preact.h)("div", {
      className: "topic-header__author-info"
    }, (0, _preact.h)(_UserAvatar.default, {
      user: user,
      extraClass: "avatar avatar--responsive",
      showRank: true
    }), (0, _preact.h)("div", {
      className: "author-info-wrapper"
    }, (0, _preact.h)("div", {
      className: "author-info"
    }, (0, _preact.h)(_UserName.default, {
      user: user,
      extraClass: "username"
    }), (0, _preact.h)(_Label.default, {
      label: (0, _preact.h)(_phrase.default, {
        p: "best.answer.accepted.solution",
        m: "Forum"
      }),
      variant: "success"
    })), (0, _preact.h)("div", {
      className: (0, _classnames.default)('author-info', {
        'dot-seperated': userRankTitle && replyTime
      })
    }, userRankTitle && (0, _preact.h)("span", {
      className: "rank-title"
    }, userRankTitle), replyTime && (0, _preact.h)(_DateTimeWithTooltip.default, {
      replyTime: replyTime
    }))))), (0, _preact.h)("div", {
      className: "post qa-topic-post-box"
    }, (0, _preact.h)("div", {
      className: "threaded-reply-body-wrapper best-answer"
    }, (0, _preact.h)(_Content.default, {
      content: content,
      className: "reply__content"
    }), authorSignature && (0, _preact.h)("div", {
      className: "signature"
    }, authorSignature))), postUrl && (0, _preact.h)("div", {
      className: "topic-footer"
    }, (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)(postUrl),
      className: (0, _classnames.default)('link', 'link--underline', 'view-in-thread')
    }, (0, _preact.h)(_phrase.default, {
      p: "view.in.thread",
      m: "Forum"
    })))));
  } // Simple display (default, feature flag disabled)


  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('qa-answer-field', 'reply-flexbox', 'reply-flexbox--bestanswer')
  }, (0, _preact.h)("div", {
    className: "reply-header"
  }, (0, _preact.h)("div", {
    className: "reply-icon-wrapper"
  }, (0, _preact.h)(_Answer.default, {
    className: "icon--checkmark",
    width: 20,
    height: 20
  })), (0, _preact.h)("div", null, (0, _preact.h)("strong", {
    className: "reply-label"
  }, (0, _preact.h)(_phrase.default, {
    p: "Best answer by",
    m: "Forum"
  }), " ", username))), (0, _preact.h)(_Content.default, {
    content: content,
    className: "reply__content"
  }), postUrl && (0, _preact.h)("div", {
    className: "reply-footer"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(postUrl),
    className: (0, _classnames.default)('link', 'link--underline', 'view-in-thread')
  }, (0, _preact.h)(_phrase.default, {
    p: "view.in.thread",
    m: "Forum"
  }))));
};

var _default = BestAnswer;
exports.default = _default;